import { useTranslation } from 'next-i18next'
import MessageIcon from 'assets/icons/nucleo/18px_message.svg'
import { LinkWithoutDecorationFullWidth } from 'components/Auth/AuthModal.style'
import { NavigationItem } from 'components/Layout/Header/DisciplineContent/NavigationItem'
import { minWidthIcon } from 'components/Layout/Header/Header.style'

export const ContactUsButton = () => {
  const { t } = useTranslation('home')
  return (
    <LinkWithoutDecorationFullWidth href="/contact" passHref>
      <NavigationItem
        leftIcon={<MessageIcon css={minWidthIcon} />}
        text={t('contactUs')}
      />
    </LinkWithoutDecorationFullWidth>
  )
}
